import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=2c11a640&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports